export enum TouchesPermisesEnum {
  BACKSPACE = 8,
  DELETE = 46,
  ARROWLEFT = 37,
  ARROWRIGHT = 39,
  ARROWUP = 38,
  ARROWDOWN = 40,
  TAB = 9,
}
export default TouchesPermisesEnum;
